import React, { FC } from 'react';
import { SlotComponentProps } from '../../types';
import { BuildPCPicker } from 'components/mobile/organisms';

export type BuildPCPickerMobileSlotProps = SlotComponentProps<{}>;

export const BuildPCPickerMobileSlot: FC<BuildPCPickerMobileSlotProps> = () => {
  return <BuildPCPicker />;
};
